import { faQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CORAL, MUTED, NAVY } from "../constants";
import { FilterCard } from "./FilterCard";

export function FiltersPanel({
  filters,
  options,
  quarterOptions,
  childCompanyOptions,
  serviceOptions,
  isFiltersLoading,
  canLoadData,
  errorMessage,
  onYearChange,
  onQuarterChange,
  onParentCompanyChange,
  onChildCompanyChange,
  onCarrierChange,
  onServiceChange,
  onReset,
}) {
  return (
    <section className="relative rounded-2xl border border-[#d9e1ee] bg-white px-5 py-5 shadow-sm">
      <div className="mb-5 flex items-center justify-between gap-4">
        <div className="pl-3" style={{ borderLeft: `3px solid ${CORAL}` }}>
          <h2 className="text-xs font-black uppercase tracking-[0.2em]" style={{ color: NAVY }}>Filters</h2>
          <p className="text-[11px] mt-0.5" style={{ color: MUTED }}>
            {canLoadData ? "Refine the data below" : "Select year and quarter to load data"}
          </p>
        </div>
        <button
          type="button"
          onClick={onReset}
          className="rounded-xl border px-4 py-2 text-xs font-bold transition hover:bg-[#f6f8fc]"
          style={{ borderColor: "#d0d9e7", color: MUTED }}
        >
          Reset
        </button>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
        <FilterCard
          label="Fin Year"
          value={filters.financialYear}
          options={options.financialYears}
          onChange={onYearChange}
          disabled={isFiltersLoading}
          isLoading={isFiltersLoading}
          placeholder="Select financial year"
        />
        <FilterCard
          label="Fin Quarter"
          value={filters.financialQuarter}
          options={quarterOptions}
          onChange={onQuarterChange}
          disabled={isFiltersLoading || !filters.financialYear}
          isLoading={isFiltersLoading}
          placeholder={filters.financialYear ? "Select financial quarter" : "Select financial year first"}
        />
        <FilterCard
          label="Parent Company"
          value={filters.parentCompany}
          options={options.parentCompanies}
          onChange={onParentCompanyChange}
          isMulti
          disabled={isFiltersLoading}
          isLoading={isFiltersLoading}
          placeholder="All companies"
        />
        <FilterCard
          label="Child Company"
          value={filters.childCompany}
          options={childCompanyOptions}
          onChange={onChildCompanyChange}
          isMulti
          disabled={isFiltersLoading}
          isLoading={isFiltersLoading}
          placeholder="All entities"
        />
        <FilterCard
          label="Carrier"
          value={filters.carrier}
          options={options.carriers}
          onChange={onCarrierChange}
          isMulti
          disabled={isFiltersLoading}
          isLoading={isFiltersLoading}
          placeholder="All carriers"
        />
        <FilterCard
          label="Service"
          value={filters.service}
          options={serviceOptions}
          onChange={onServiceChange}
          isMulti
          disabled={isFiltersLoading || !filters.carrier.length}
          isLoading={isFiltersLoading}
          placeholder={filters.carrier.length ? "All services" : "Select carrier first"}
        />
      </div>

      {errorMessage ? (
        <div className="mt-4 rounded-xl border border-[#ffd0d2] bg-[#fff5f5] px-4 py-3 text-sm font-semibold text-[#b42318]">
          {errorMessage}
        </div>
      ) : null}

      <div className="group absolute bottom-3 right-4">
        <button
          type="button"
          className="flex h-6 w-6 items-center justify-center rounded-full border bg-white text-[10px] font-black shadow-sm transition-colors hover:bg-[#f6f8fc] focus:outline-none focus:ring-2 focus:ring-[#144677]/20"
          style={{ borderColor: "#d0d9e7", color: NAVY }}
          aria-label="Spend values exclude tax"
          title="All spend values are excluding tax."
        >
          <FontAwesomeIcon icon={faQuestion} />
        </button>
        <div
          className="pointer-events-none absolute bottom-8 right-0 z-20 w-56 rounded-lg bg-[#102f52] px-3 py-2 text-left text-[11px] font-semibold leading-snug text-white opacity-0 shadow-lg transition-opacity group-hover:opacity-100 group-focus-within:opacity-100"
        >
          All spend values are excluding tax.
        </div>
      </div>
    </section>
  );
}
